module.exports = __webpack_public_path__ + "WFM_logo.534aeb23aba2cb23249e4f3d4d34e3bd.png";